define.alias("ember-math-helpers/helpers/min", "settings/helpers/min");